import { cn } from "../cn";

// --muted bars, radius 6 (design spec §8.3). Callers mark the loading region `aria-busy`.
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("animate-pulse rounded-sm bg-muted", className)}
      {...props}
    />
  );
}

export { Skeleton };
